// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".apple-pay-container,.olo-pay-container{padding-top:16px}apple-pay-button{--apple-pay-button-width:100%;--apple-pay-button-height:56px;--apple-pay-button-border-radius:8px;--apple-pay-button-padding:0px 0px;--apple-pay-button-box-sizing:border-box}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
